export const ru = {
    'leningrad-region': 'Санкт-Петербург и область',
    'moscow-region': 'Москва и область',
    'russia-cis-georgia': 'Россия, СНГ и Грузия',
    ukraine: 'Украина'
};
